export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "About Us",
  headline: "100% Australian Owned & Operated",
  description:
    "Established over 10 years ago, we have extensive project experience across all areas of construction from commercial works through to industrial and mining projects. D&L Constructions have successfully delivered a broad range of projects, positioning us as leading contractors within the industry.",
  buttonLabel: "Get In Touch",
  imgStart: false,
  img:
    "https://full-stack-app.s3-ap-southeast-2.amazonaws.com/images/svg-1.png",
  alt: "Icon",
  dark: false,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "services",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Our Services",
  headline: "Plastering & Gyprock Specialist",
  description:
    "We can take on any type of construction work from small complex works to large-scale projects. Our services include cladding, rendering, partitioning, plastering, glass partition, insulation and more.",
  buttonLabel: "Contact Us",
  imgStart: true,
  img:
    "https://full-stack-app.s3-ap-southeast-2.amazonaws.com/images/svg-2.png",
  alt: "Icon",
  dark: false,
  primary: true,
  darkText: true,
};

export const homeObjThree = {
  id: "careers",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Careers",
  headline: "Join our team",
  description:
    "If you are interested in working for us, please feel free to contact us.",
  buttonLabel: "Work With Us",
  imgStart: false,
  img:
    "https://full-stack-app.s3-ap-southeast-2.amazonaws.com/images/svg-3.png",
  alt: "Icon",
  dark: false,
  primary: true,
  darkText: true,
};
